import "./notFound.scss";
import { useNavigate } from "react-router-dom";

// image
import { images } from "../../constants/images";

// svg
import { ReactComponent as NotFoundSvg } from "../../assets/svg/not-found.svg";

const NotFound = () => {
    const navigate = useNavigate()
    return (
    <div className="notFound">
      <div className="topbar">
        <img src={images.topbar} alt="Top bar" />
      </div>
      <div className="messageBoard">
        <NotFoundSvg />
      </div>
        <span className="nf">404</span>
        <span className="msg">Something Went Wrong!</span>
        <button className="redirect"
        onClick={()=>{
            navigate('/')
        }}
        >
            Back to Homepage
        </button>
    </div>
  );
};

export default NotFound;
